import { message } from "antd";
import axios from "axios";
import globalRouter from "globalRouter.ts";

const SECONDS = 60;
const MILISECONDS = 1000;
const TIMEOUT = SECONDS * MILISECONDS;
const REACT_APP_BASE_API = process.env.REACT_APP_BASE_API;

const PrivateNetworkClient = axios.create({
    baseURL: REACT_APP_BASE_API,
    timeout: TIMEOUT,
    headers: {
        "Content-Type": "application/json",
    },
});

PrivateNetworkClient.interceptors.request.use(config => {
    const jwtToken = localStorage.getItem("token")
    if (jwtToken) {
        config.headers["authorization"] = 'Bearer ' + jwtToken
    }
    if (!jwtToken && !config.headers["public-request"]) {
    }
    return config
}, error => {
    return Promise.reject(error)
})

PrivateNetworkClient.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error?.response?.data instanceof Blob) {
            // File downloads (responseType: 'blob') hand back the error body as a Blob, so there
            // is no .message to read -- without this the toast comes up empty.
            message.error("Download failed. Please try again.");
        } else if (error?.response?.data) {
            message.error(error?.response?.data?.message);
        } else if (error.response.status !== 200) {
            if (error.response.status === 401 && globalRouter.navigate) {
                localStorage.removeItem('token');
                globalRouter.navigate("/login", { state: { message: "Session Time Out! Please ReLogin." } });
            } else {
                message.error(error.response.data.data);
            }
        } else {
            console.error(error);
        }
        return Promise.reject(error);
    }
);

export default PrivateNetworkClient;